<fieldset>
 <legend>
  Procedure
 </legend>
 <app-form-input
[parentForm]="parentForm"
[value]="procedure.autres"

[label]="'autres'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_autres'">
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="procedure.procedureAdaptee"

[label]="'procedureAdaptee'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_procedureAdaptee'">
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="procedure.appelOuvert"

[label]="'appelOuvert'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_appelOuvert'">
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="procedure.dialogueCompetitif"

[label]="'dialogueCompetitif'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_dialogueCompetitif'">
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="procedure.concoursRestreint"

[label]="'concoursRestreint'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_concoursRestreint'">
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="procedure.appelRestreint"

[label]="'appelRestreint'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_appelRestreint'">
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="procedure.marcheNegocie"

[label]="'marcheNegocie'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_marcheNegocie'">
</app-form-input>

<!---->

<app-form-input
[parentForm]="parentForm"
[value]="procedure.concoursOuvert"

[label]="'concoursOuvert'"
[type]="'text'" [rule]="''"
[name]="getUid()+'_SepAtt_concoursOuvert'">
</app-form-input>
</fieldset>
